exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{user-select:auto;-webkit-tap-highlight-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/ProjectsListWrapper/ProjectsListWrapper.scss
// module id = 1874
// module chunks = 0